import { Box, Flex, Grid, Text } from "@theme-ui/components";
import { saveAs } from "file-saver";
import React from "react";
import AppButton from "../layout/app-button";
import ColumnContainer from "../layout/column-container";
import ShareButton from "../share-button";
import { useStaticQuery, graphql } from "gatsby";
import eventTrack from "../../lib/event-track";

const PdfDownload = ({ articleTitle }) => {
  const data = useStaticQuery(graphql`
    query pdfImageQuery {
      image: file(relativePath: { eq: "download-pdf.jpg" }) {
        c: childImageSharp {
          f: fluid(maxWidth: 600, quality: 100) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `);
  return (
    <ColumnContainer>
      <Grid id="download-pdf" columns={[1, 1, 3, 2]} gap={0}>
        <Box
          sx={{
            bg: "highlight",
            borderRadius: ["30px 30px 0 0", null, "30px 0 0 30px"],
            gridColumn: ["span 1", "span 2", null, "span 1"],
          }}
        >
          <Grid sx={{ p: [4, 5] }} columns={1} gap={[4]}>
            <Text
              sx={{
                color: "white",
                fontSize: [4, 5, 6],
                lineHeight: 1.4,
              }}
              as="h2"
            >
              Download a PDF version.
            </Text>
            <Text
              as="p"
              sx={{
                color: "white",
                lineHeight: 1.7,
              }}
            >
              Download a copy of this content to your device as a PDF file. We
              generate PDF versions for the convenience of offline reading, but
              we recommend sharing this link if you'd like to send it to someone
              else.
            </Text>
            <Grid columns={2}>
              <Box>
                <ShareButton color="blue" articleTitle={articleTitle} />
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Flex
          sx={{
            backgroundImage: `url(${data.image.c.f.src})`,
            borderRadius: ["0px 0px 30px 30px", null, "0px 30px 30px 0px"],
            justifyContent: "center",
            alignItems: "center",
            minHeight: [300, null, "auto"],
          }}
        >
          <AppButton
            color="purple"
            colors={{
              default: {
                background: "purple",
                text: "white",
              },
            }}
            icon="arrowDown"
            onClick={() => {
              if (window.location.hostname === "localhost") {
                return alert("PDF downloads only work in production");
              }
              eventTrack("PDF Downloaded", {
                props: {
                  url: window.location.pathname,
                },
              });
              const url =
                window.location.origin +
                window.location.pathname +
                "/document.pdf";
              saveAs(url, window.location.pathname + ".pdf");
            }}
          >
            Download PDF
          </AppButton>
        </Flex>
      </Grid>
    </ColumnContainer>
  );
};

export default PdfDownload;
